export default (value: number | null | undefined, message: string, errorValue: any = -1) => {
	if (!value) {
		console.error(`ERROR: (income = ${value}) -> ${message}`);
		return errorValue;
	}

	return value;
};
